import { FC, PropsWithChildren } from 'react'
import { Listbox } from '@headlessui/react'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { twMerge } from 'tailwind-merge'

type DropDownProps = {
  open?: boolean
  right?: boolean
  selectedItems?: string[]
  setSelected?(x: string[]): void
}

export const DropDown: FC<PropsWithChildren<DropDownProps>> = ({
  children,
  open,
  right,
  setSelected,
}) => {
  const { t } = useTranslation('dashboard')

  return (
    <Listbox as='div' className='relative' onChange={setSelected} multiple>
      {({ open: o }) => {
        return (
          <>
            <Listbox.Button
              className={twMerge(
                'hover:text-blue-600 dark:hover:bg-gray-800',
                'capitalize inline-flex w-full justify-center rounded-md bg-white dark:bg-gray-800 px-4 py-2 text-sm shadow-sm',
                'focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-100'
              )}
            >
              {t('filter') as string}
              <svg
                className={twMerge(
                  'ltr:-mr-1 ltr:ml-2 rtl:-ml-1 rtl:mr-2 h-5 w-5',
                  o ? 'rotate-180' : ''
                )}
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 20 20'
                fill='currentColor'
              >
                <title>{t('filter-issues')}</title>
                <path
                  fillRule='evenodd'
                  d='M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z'
                  clipRule='evenodd'
                />
              </svg>
            </Listbox.Button>
            <Listbox.Options
              className={twMerge(
                'border absolute ltr:right-0 rtl:left-0 z-30 mt-2 w-42 rounded-sm shadow-lg ring-opacity-5 focus:outline-none',
                !open
                  ? 'bottom-0 ltr:right-24 rtl:left-24 ltr:lg:right-0 rtl:lg:left-0 ltr:origin-bottom-left rtl:origin-bottom-right lg:bottom-[inherit]'
                  : 'ltr:origin-top-right rtl:origin-top-left',
                right
                  ? 'ltr:origin-top-right rtl:origin-top-left ltr:-right-24 rtl:-left-24 w-[12vw] min-w-[210px] md:min-w-[22rem]'
                  : 'md:w-[22vw]'
              )}
            >
              {children}
            </Listbox.Options>
          </>
        )
      }}
    </Listbox>
  )
}
